import { render, staticRenderFns } from "./DemandePermisInscriptionTableau.vue?vue&type=template&id=31df1133"
import script from "./DemandePermisInscriptionTableau.vue?vue&type=script&lang=js"
export * from "./DemandePermisInscriptionTableau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports